<template>
    <div>
        <app-page-header :title="insightDetail.title" class="news-banner" />
        <app-content-loader v-if="$apollo.loading" title="News" />
        <b-container v-else>
            <div class="wrapper">
                <div class="news-detail">
                    <div class="tag" v-if="insightDetail.tags">
                        <b-badge href="#" variant="light" v-for="(tag, index) in insightDetail.tags" :key="index" class="badge">{{ tag }}</b-badge>
                    </div>
                    <div class="author">
                        <h6 v-if="insightDetail.authorId"><strong>{{ insightDetail.author.name }}</strong>{{ authorTitleCompanyName }}</h6>
                        <time>{{ displayPublishedAt }} - {{ insightDetail.duration }}</time>
                    </div>
                    <div class="content">
                        <div class="text" v-html="insightDetail.content"></div>
                        <div v-if="insightDetail.mediaUrl" class="mt-4 embed-responsive embed-responsive-16by9 z-depth-1-half">
                            <iframe class="embed-responsive-item" :src="insightDetail.mediaUrl" allowfullscreen ></iframe>
                        </div>
                    </div>
                    <app-social-sharing class="share" :url="$route.path" :title="insightDetail.name"></app-social-sharing>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
import GetInsightDetail from '@/graphql/GetInsightDetail.gql';
import AppPageHeader from '@/components/global/AppPageHeader';
import AppContentLoader from '@/components/global/AppContentLoader';
import AppSocialSharing from '@/components/global/AppSocialSharing';

export default {
    name: 'news-detail',

    components: {
        AppPageHeader,
        AppContentLoader,
        AppSocialSharing,
    },

    apollo: {
        insightDetail: {
            query: GetInsightDetail,
            variables() {
                return {
                    id: this.$route.params.id,
                };
            },
        },
    },

    data() {
        return {
            insightDetail: '',
        };
    },

    computed: {
        authorTitleCompanyName() {
            return this.insightDetail.author.companyName && ', ' + this.insightDetail.author.title + ' at ' + this.insightDetail.author.companyName;
        },

        displayPublishedAt() {
            return new Date(this.insightDetail.publishedAt).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    img {
        max-width: 100%;
    }
    .news-banner {
        .banner-content {
            max-width: 100%;
        }
    }
    .wrapper {
        padding: 20px 0 90px;
    }

    .news-detail {
        background-color:#ffffff;
        padding: 30px;

        @include media-breakpoint-up(md) {
            padding: 40px 30px;
        }

        .tag {
            margin-bottom: 30px;
        }

        .badge {
            background-color: #8e989f;
            color: #fff;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            margin-right: 7px;
            padding: 7px 9px;
        }

        .embed-responsive {
            max-width: 500px;
            max-height: 337px;
            background: rgba(0, 1, 18, 0.05);
            border: 2px solid rgba(0, 1, 18, 0.05);
        }

        .author {
            font-size: 14px;
            margin-bottom: 15px;
            @include media-breakpoint-up(md) {
                margin-top: 20px;
            }
            @include media-breakpoint-up(lg) {
                margin-top: 0;
                margin-bottom: 30px;
            }
            h6 {
                margin-bottom: 3px;
            }

            time {
                color: grey;
            }
        }

        .content {
            font-size: 15px;
            line-height: 24px;
            color: #505B64;
            margin-bottom: 20px;
            @include media-breakpoint-up(md) {
                font-size: 18px;
                line-height: 31px;
                margin-bottom: 40px;
            }

            .text ::v-deep img {
                max-width: 100%;
            }
            .text ::v-deep iframe {
                max-width: 100%;
            }
        }
    }
</style>
